import ScrollMagic from 'scrollmagic';
import { TweenLite, TimelineMax } from 'gsap';
import { ScrollMagicPluginGsap } from "scrollmagic-plugin-gsap";
ScrollMagicPluginGsap(ScrollMagic, TweenLite, TimelineMax);

const $ = window.jQuery;
const $window = window.$window || $(window);



const FadeIn = {

  init () {
    // Only Desktop
    if($window.width() >= 768){
      
      // Every Image Copy Spread
      var imageCopySpread = createImageCopySpread();
      function createImageCopySpread(){

        $('.animate-items').each(function(i,el){
          var controller = new ScrollMagic.Controller();
          // var tl = new TimelineMax();
          // tl.to($(this).find(), 1, { y: 1000, ease: Linear.easeNone });
          return new ScrollMagic.Scene({triggerElement: this, triggerHook: 'onEnter', duration: "500%"})
            .setClassToggle(this, 'animated')
            .addTo(controller);
        }); 
      }
      // Every Image Copy Spread
      var projectFade = createProjectFade();
      function createProjectFade(){
  
        $('.project-summary, .people-summary').each(function(i,el){
          var controller = new ScrollMagic.Controller();
          // var tl = new TimelineMax();
          // tl.to($(this).find(), 1, { y: 1000, ease: Linear.easeNone });
          return new ScrollMagic.Scene({triggerElement: this, triggerHook: 'onEnter', duration: "500%"})
            .setClassToggle(this, 'fadein')
            .addTo(controller);
        }); 
      }
    }
      
    
  }
}

export default FadeIn;